module.exports = __webpack_public_path__ + "07434a841ad80dc5ab4512c03a6bf947.svg";